/**
 * Geteilte Datei-Helfer fuer authentifizierte Datei-Downloads (Backlog #41: R2-Original-Dateien
 * beim Speisekarten-Import + Event-Anhaenge). Gleiches Muster wie lib/print.ts
 * (openPrintableDocument): Blob-URL statt `<a href>`, weil ein simples `<a>` den Auth-Header von
 * apiFetch nicht mitschicken koennte.
 */
import { apiFetch, toApiError } from "./api";

/** Holt `path` authentifiziert und oeffnet die Antwort als Blob-URL in einem neuen Tab. */
export async function openAuthenticatedFile(path: string): Promise<void> {
  const res = await apiFetch(path);
  if (!res.ok) throw await toApiError(res);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (win) win.addEventListener("load", () => URL.revokeObjectURL(url), { once: true });
  else URL.revokeObjectURL(url); // Popup blockiert -> keine haengende Object-URL zurueckbehalten
}

/** Datei -> {mediaType, dataBase64} (ohne data:-Praefix) fuers JSON-Body-Upload. */
export async function fileToBase64(file: File): Promise<{ mediaType: string; dataBase64: string }> {
  const buf = await file.arrayBuffer();
  let binary = "";
  const bytes = new Uint8Array(buf);
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return { mediaType: file.type || "application/octet-stream", dataBase64: btoa(binary) };
}
